import { ArrowUp } from "lucide-react";
import Logo from "./Logo";
import { NAV_LINKS, scrollToId, scrollToTop, CONTACT } from "@/lib/site";

export default function Footer() {
  return (
    <footer data-testid="footer-section" className="bg-ink text-cream relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-20 pb-8 relative z-10">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <Logo size="lg" onDark />
            <p className="text-sm leading-relaxed text-cream/50 mt-6 max-w-sm">
              Full-service interior design &amp; architectural company, Noida. We design homes that
              feel like home — warm, functional and enduring.
            </p>
          </div>

          <div className="lg:col-span-2">
            <p className="font-display text-[10px] tracking-widest2 uppercase text-brass">Explore</p>
            <div className="mt-5 flex flex-col items-start gap-3">
              {NAV_LINKS.map((l) => (
                <button key={l.id} data-testid={`footer-link-${l.id}`} onClick={() => scrollToId(l.id)} className="text-sm text-cream/60 hover:text-cream transition-colors">
                  {l.label}
                </button>
              ))}
            </div>
          </div>

          <div className="lg:col-span-3">
            <p className="font-display text-[10px] tracking-widest2 uppercase text-brass">Contact</p>
            <div className="mt-5 flex flex-col items-start gap-3 text-sm text-cream/60">
              <a href={`mailto:${CONTACT.email}`} data-testid="footer-email-link" className="hover:text-cream transition-colors break-all">{CONTACT.email}</a>
              <a href={CONTACT.phoneHref} data-testid="footer-phone-link" className="hover:text-cream transition-colors">{CONTACT.phoneDisplay}</a>
              <span data-testid="footer-address">{CONTACT.address}</span>
            </div>
          </div>

          <div className="lg:col-span-2">
            <p className="font-display text-[10px] tracking-widest2 uppercase text-brass">Credentials</p>
            <div className="mt-5 flex flex-col gap-3 text-xs leading-relaxed text-cream/45">
              <span>MSME · UDYAM-UP-28-0029913</span>
              <span>WICCI Delhi Design Council President — 2020</span>
              <span>WICCI Iconic Women Award — 2026</span>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-16 pt-6 flex items-center justify-between gap-6">
          <p data-testid="footer-copyright-text" className="text-[11px] tracking-wide text-cream/40">
            © 2026 The Studio31 · Interior Design &amp; Architecture, Noida
          </p>
          <button
            data-testid="footer-back-to-top-btn"
            onClick={scrollToTop}
            aria-label="Back to top"
            className="h-11 w-11 border border-brass/40 flex items-center justify-center hover:bg-brass hover:text-ink transition-colors duration-300 shrink-0"
          >
            <ArrowUp size={16} />
          </button>
        </div>
      </div>

      <div
        aria-hidden
        data-testid="footer-watermark"
        className="absolute -bottom-[4vw] inset-x-0 text-center font-serif text-[17vw] leading-[0.8] text-white/5 select-none pointer-events-none"
      >
        STUDIO 31
      </div>
    </footer>
  );
}
